import { render, staticRenderFns } from "./heziShop.vue?vue&type=template&id=cd83c3be&scoped=true&"
import script from "./heziShop.vue?vue&type=script&lang=js&"
export * from "./heziShop.vue?vue&type=script&lang=js&"
import style0 from "./heziShop.vue?vue&type=style&index=0&id=cd83c3be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd83c3be",
  null
  
)

export default component.exports